
import { appDownload } from '@/api/baseurl'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
XButton
},
data () {
return {


androidInvestorUrl: appDownload.androidInvestorUrl, // 投资者
androidFinancialUrl: appDownload.androidFinancialUrl, // 企业版
iosInvestorUrl: appDownload.iosInvestorUrl,
iosFinancialUrl: appDownload.iosFinancialUrl,
isWeiXin: false,
appName: '',
notMatch: true
}
},
created () {
this.initDownload()
console.log('process.env.VUE_APP_MODE ---', process.env.VUE_APP_MODE)
},
methods: {
initDownload () {
let u = navigator.userAgent

this.appName = Number(this.$route.query.isInvestor) === 1 ? '妥私募' : '妥私募企业版'

this.isWeiXin = u.indexOf('MicroMessenger') > -1
if (this.isWeiXin) { // 微信里面不进行下载
return
}

let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1

let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
if (this.isDev) {
console.log(`isAndroid:${isAndroid},isiOS:${isiOS}, query:${JSON.stringify(this.$route.query)}`)
} else {
if (isAndroid) {
this.toDownload(1)
} else if (isiOS) {
this.toDownload(2)
} else {








this.notMatch = true
}
}
},

toDownload (version) {
if (version === 1) {
if (Number(this.$route.query.isInvestor) === 1) {

window.location.href = this.androidInvestorUrl
} else {

window.location.href = this.androidFinancialUrl
}
} else if (version === 2) {
if (Number(this.$route.query.isInvestor) === 1) {

window.location.href = this.iosInvestorUrl
} else {

window.location.href = this.iosFinancialUrl
}
} else {
const _this = this
this.$vux.alert.show({
title: '提示',
content: '未检测到设备信息',
onHide () {
_this.$router.go(-1)
}
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Download/index.vue